import { number } from 'valibot';

export const paginationScheme = {
	count: number(),
	num_pages: number(),
	page: number(),
	page_size: number(),
};
